import type { SVGProps } from 'react';

export const SocialTelegram = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.996799 7.16479C4.88911 5.46897 7.48459 4.35098 8.78324 3.81083C12.4912 2.26858 13.2616 2.00067 13.7638 1.99182C13.8743 1.98988 14.1212 2.01725 14.2812 2.14706C14.4163 2.25666 14.4534 2.40472 14.4712 2.50864C14.489 2.61256 14.5112 2.84928 14.4936 3.03425C14.2926 5.14548 13.4232 10.2689 12.9809 12.6335C12.7937 13.634 12.4252 13.9695 12.0684 14.0023C11.293 14.0737 10.7043 13.4899 9.95329 12.9977C8.77816 12.2274 8.11429 11.7478 6.97362 10.9961C5.65539 10.1275 6.50994 9.65 7.2612 8.86971C7.45781 8.66551 10.8741 5.55815 10.9402 5.27627C10.9485 5.24101 10.9561 5.1096 10.8781 5.04021C10.8 4.97082 10.6848 4.99455 10.6016 5.01342C10.4838 5.04017 8.60648 6.28099 4.96978 8.73586C4.43692 9.10177 3.95427 9.28005 3.52183 9.2707C3.04511 9.2604 2.12808 9.00115 1.44636 8.77955C0.610203 8.50775 -0.0543554 8.36405 0.00351276 7.90245C0.0336541 7.66202 0.36475 7.41613 0.996799 7.16479Z"
        fill="currentColor"
      />
    </svg>
  );
};
